import React from 'react';
import { motion } from 'framer-motion';
import legalImg from '../images/photos/legal.gif'; // replace with your actual image path

const pageVariants = {
  initial: { rotateY: 90, opacity: 0 },
  in: { rotateY: 0, opacity: 1 },
  out: { rotateY: -90, opacity: 0 }
};

const pageTransition = {
  type: 'spring',
  stiffness: 80,
  damping: 20
};

const Industries_LegalLawFirm = () => (
  <motion.div
    initial="initial"
    animate="in"
    exit="out"
    variants={pageVariants}
    transition={pageTransition}
    style={{
      minHeight: '60vh',
      padding: '20px',
      fontFamily:
        "Inter, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial",
      backgroundColor: '#f8fafc',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}
  >
    {/* Page Heading */}
    <h1
      style={{
        fontSize: '34px',
        marginBottom: '24px',
        textAlign: 'center',
        color: '#1e293b'
      }}
    >
      Legal & Law Firm
    </h1>

    <section
      style={{
        maxWidth: '1200px',
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '20px'
      }}
    >
      {/* Left: Image */}
      <div style={{ flex: '1 1 300px', display: 'flex', justifyContent: 'center' }}>
        <img
          src={legalImg}
          alt="Legal and Law Firm sector"
          style={{
            width: '100%',
            maxWidth: '500px',
            height: 'auto',
            borderRadius: '12px',
            boxShadow: '0 6px 20px rgba(0,0,0,0.08)'
          }}
        />
      </div>

      {/* Right: Content */}
      <div style={{ flex: '1 1 300px' }}>
        <p style={{ color: '#475569', lineHeight: 1.6 }}>
          Innovating Legal Operations for Better Efficiency and Security. Zyntro Software Solutions
          Pvt. Ltd. specializes in providing innovative and secure technology solutions tailored to
          the needs of law firms and legal organizations. With a focus on efficiency, compliance,
          and data security, we offer cutting-edge solutions that streamline case management,
          document automation, client communication, and legal research.
        </p>
        <p style={{ color: '#475569', lineHeight: 1.6 }}>
          Our services are designed to help law firms maximize their productivity while ensuring
          they meet the highest standards of confidentiality and compliance. From custom software
          development and legal analytics to cloud-based document management systems, our solutions
          empower legal professionals to focus on delivering exceptional service to their clients.
        </p>
        <p style={{ color: '#475569', lineHeight: 1.6 }}>
          Whether you’re a small law practice or a large legal firm, Zyntro Software Solutions Pvt.
          Ltd. provides the tools you need to enhance operations, improve client relationships, and
          stay ahead in the competitive legal industry.
        </p>
      </div>
    </section>
  </motion.div>
);

export default Industries_LegalLawFirm;
